// 緊急メッセージのエンティティ
export class LessonMessage {
  // メッセージID DB型(*autokey)
  public message_id?: number;
  // メッセージ文 DB型(MEDIUMTEXT)
  public message_contents?: string;
  // レッスンID DB型(*autokeyFk)
  public class_id?: number;
  // 生徒ユーザーID DB型(*fk)
  public student_user_id?: string;
  // 先生ユーザーID DB型(*fk)
  public teacher_user_id?: string;
  // 送信日時 DB型(DATETIME)
  public send_dt?: Date;
  // 送信元ユーザーID DB型(*fk)
  public from_user_id?: string;
  // 既読 DB型(*flg)
  public read_yet?: boolean;
  static fromDB(record: { [column: string]: any; [column: number]: any }): LessonMessage {
    const entity = new LessonMessage();
    entity.message_id = record['message_id'];
    entity.message_contents = record['message_contents'];
    entity.class_id = record['class_id'];
    entity.student_user_id = record['student_user_id'];
    entity.teacher_user_id = record['teacher_user_id'];
    entity.send_dt = record['send_dt'];
    entity.from_user_id = record['from_user_id'];
    entity.read_yet = record['read_yet'];
    return entity;
  }
  static getTypeFitEntity(value: any): LessonMessage {
    const entity = new LessonMessage();
    entity.message_id = value.message_id;
    entity.message_contents = value.message_contents;
    entity.class_id = value.class_id;
    entity.student_user_id = value.student_user_id;
    entity.teacher_user_id = value.teacher_user_id;
    entity.send_dt = value.send_dt;
    entity.from_user_id = value.from_user_id;
    entity.read_yet = value.read_yet;
    return entity;
  }
}
